
<template>
  <el-row
    v-loading="isLoading"
    :gutter="15"
  >
    <el-col :span="4">
      <Filters
        v-model="filters"
        class="mb-3"
        :resource="$sdk.carrier_time"
        :primary-fields="[ 'from', 'to' ]"
        @apply="reload"
        @ready="load"
      />
    </el-col>
    <el-col :span="20">
      <el-card shadow="never">
        <TimeTable
          :times="times"
        />
        <br>
        <div style="text-align: center;">
          <el-pagination
            :current-page.sync="times.page"
            :page-size.sync="times.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="times.total"
            @size-change="reload"
            @current-change="reload"
          />
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import TimeTable from '@/components/Application/Manage/Carriers/Times/Table'
import Filters from '@/components/Filters/Simplified'

export default {
  components: {
    TimeTable,
    Filters
  },
  data () {
    return {
      title: 'Times',
      breadcrumb: {
        name: 'Times',
        route: { name: 'manage-carriers-carrier-times', params: { carrierId: this.$route.params.carrierId } }
      },
      actions: [
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => {
            this.reload()
          }
        }
      ],
      isLoading: true,
      isSaving: false,
      carrier: null,
      times: [],
      filters: []
    }
  },
  created () {
    // this.load()
  },
  methods: {
    async load () {
      this.isLoading = true

      this.times = await this
        .$sdk
        .carrier_time
        .list(request => {
          request.context = { resource: 'carrier', identifier: this.$route.params.carrierId }
          request.limit = 100
        })

      this.isLoading = false
    },
    async reload () {
      try {
        this.isLoading = true
        await this.times.reload(request => {
          request.filters = this.filters
        })
      } catch {
        this.$message.error('An error occurred while loading times')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
